import Firebase from 'firebase'

const firebaseApp = Firebase.initializeApp({
  apiKey: 'AIzaSyAGc1hS555qGeg4Y47PFMPfiIanLvyIlcg',
  authDomain: 'thomas-fe69b.firebaseapp.com',
  databaseURL: 'https://thomas-fe69b.firebaseio.com',
  projectId: 'thomas-fe69b',
  storageBucket: 'thomas-fe69b.appspot.com',
  messagingSenderId: '808989085103'
})

export const db = firebaseApp.database()



// WEBPACK FOOTER //
// ./src/firebase.js